import { gql } from '@apollo/client';

const GET_UNITS = gql`
  query getUnits($unitsWhere: UnitsWhereInput) {
    units(where: $unitsWhere) {
      productCurriculumId
      title
      unitNumber
      id
    }
  }
`;

export default GET_UNITS;
